module.exports = __webpack_public_path__ + "img/courthouse.31e0999e.svg";